import { VRow, VCol, VBtn, VIcon } from 'vuetify/lib'
import VModal from '@/vuetify_custom/v-modal_v1'
import VForm from '@/vuetify_custom/v-form'
import AutocompletesAsyncS from '@/vuetify_custom/v-form/components/Autocompletes_Async.js'
import PlanModalChild from './plan_modal_child'
import styles from './plan_modal.module.less'
import { generateCostPlanBillApi } from './../services'
import { generate_child_fileds, generate_master_fileds } from './../utils'
import plan_form from '../mixins/plan_form'
export default {
    mixins: [ plan_form ],
    data() {
        return {
            title: '新增',
            value: generate_master_fileds(),
        }
    },
    computed: {
        fields() {
                return [
                  this.apply_user_field,
                  this.fill_user_field,
                  this.company_field,
                  this.team_filed,
                  this.bills_name,
                  this.contract_field,
                  this.payee_company_account_field,
                  {
                    label: '计划开始日期',
                    key:'consume_started_at',
                    type:'date_picker',
                    cols: 6,
                    allowedDates:(date) => {
                      return !(this.value.consume_ended_at && this.value.consume_ended_at < date)
                    },
                    rules:[val => {
                      return !!val || '计划开始日期必选'
                    }],
                  },
                  {
                    label: '计划结束日期',
                    key:'consume_ended_at',
                    type:'date_picker',
                    cols: 6,
                    allowedDates:(date) => {
                      return !(this.value.consume_started_at && this.value.consume_started_at > date)
                    },
                    rules:[val => {
                      return !!val || '计划结束日期必选'
                    }],
                  }
                ]
              }
    },
    created() {
    
    },
    methods: {
        show(data) {
            if (!data) {
              this.value = generate_master_fileds()
            }
            this.value.fill_user_id = this.cur_customer.id
            this.value.fill_user = this.cur_customer.account;
            this.value.apply_user_id = this.value.fill_user_id
            this.apply_user_list = [
              {
                  id: this.value.fill_user_id,
                  account: this.value.fill_user 
              }
          ]
            this.dis = true
        },
        showHasData(data) {
          this.value = generate_master_fileds()
          data && (this.contract_list = [{
            ...data,
            text_name: `${data.uid}-${data.name}`
          }])
          data && (this.value.contract_id = data.id)
          if (data && data.consume_schedule) {
            this.value.consume_started_at = data.consume_schedule.start_date
            this.value.consume_ended_at = data.consume_schedule.end_date
          }
          this.value.fill_user_id = this.cur_customer.id
          this.value.fill_user = this.cur_customer.account;
          this.value.apply_user_id = data.apply_user_id
          this.apply_user_list = [
            {
                id: data.apply_user_id,
                account: data.apply_user
            }
        ]
          this.dis = true
        },
        ok() {
          const arr = [this.$refs.master]
          let is_ok = true
          let index = 0
          while (this.$refs[`child-${index++}`]) {
            arr.push(this.$refs[`child-${index - 1}`])
          }
          arr.forEach(item => {
            const cur_is_ok = item.validate()
            if (!cur_is_ok) {
              is_ok = false
            }
          })
          if (is_ok) {
            this.saving = true
            generateCostPlanBillApi(this.value).then(() => {
              this.dis = false
              this.$Message.success({content:'新增成功！'})
              this.$emit('success')
            }).finally(() => {
              this.saving = false
            })
          }
        },
        addNew() {
          this.value.entries.push(generate_child_fileds())
        },
        delItem(index) {
          this.$vModal.confirm({
            title:'提示',
            content: `确定删除第${ index + 1 }条科目`,
            onOk:() => {
              this.value.entries.splice(index, 1)
            }
          })
        }
    },
    render() {
        const entries = this.value.entries
        return <VModal 
            v-model={this.dis}
            title={this.title}
            loading={this.saving}
            ref="modal"
            fullscreen
            on={{
              ok: this.ok
            }}
        >
            <div class={styles.content}>
                <VForm
                  v-model={this.value} 
                  fields={this.fields}
                  ref="master"
                  scopedSlots={{
                    apply_user_id:({field}) => {
                            return <AutocompletesAsyncS
                            v-model={this.value}
                            field={{
                              ...field,
                              items: this.apply_user_list
                            }}
                        />},
                    payee_company_account_id:({field}) => {
                          return <AutocompletesAsyncS
                          v-model={this.value}
                          field={{
                            ...field,
                            items: this.account_payee_list
                          }}

                       
                      />
                    },
                    contract_id:({field}) => {
                      return <AutocompletesAsyncS
                      v-model={this.value}
                      field={{
                        ...field,
                        items: this.contract_list
                      }}
                  />
                }
                  }}
                />
               {
                  entries.map((child, index) => (
                  <div key={child.index} class={styles['expense-wrapper']}>
                    <PlanModalChild
                      ref={`child-${index}`}
                      show-button
                      index={ index }
                      v-model={ child }
                     />
                     <VRow>
                       <VCol>
                          <VBtn
                            color="primary"
                            block
                            on={{
                              click: this.addNew
                            }}
                          >
                              <VIcon>
                                mdi-plus
                              </VIcon>
                                添加项目
                            </VBtn>
                       </VCol>
                       {entries.length > 1 && <VCol>
                          <VBtn
                            color="orange"
                            block
                            on={{
                              click:() => this.delItem(index)
                            }}
                          >
                              <VIcon>
                                mdi-close
                              </VIcon>
                              删除项目{ index + 1 }
                            </VBtn>
                       </VCol>}
                     </VRow>
                  </div>
                 ))
               }
            </div>
                
            </VModal>
    }
}